<div class="flex flex-row items-center">
    <input class="flex-1" type="text" [(ngModel)]="searchTerm" (ngModelChange)="search()"
        [placeholder]="'MENU.SEARCH.INPUT' | translate">
</div>

<div class="results">
    <div class="list">
    @for (item of visibleItems; track $index) {
        <div class="list-item">
            <div class="content">
                <span class="title text-lg">{{item.title}}</span>
                <span class="md:text-right">{{item.caption}}</span>
                @if (castToProduct(item) && $any(item).manual) {
                <a class="action max-md:hidden" (click)="openManual($event, item)">{{ 'PRODUCT.MANUAL' | translate }}</a>
                }
                <a class="action col-start-4" [routerLink]="[ castToProduct(item) ? '/reagents' : '/systems' , item.slug]"
                    (click)="close.emit()">
                    {{ 'MENU.SEARCH.SHOW_DETAILS' | translate | replaceWhitespaceWithUnderscore }}
                </a>
            </div>
            <app-media class="media" [media]="item.media"></app-media>
        </div>
    }
    @if (visibleItems.length == 0 && !!searchTerm.length) {
        <div class="list-item">
            <div class="content">
                <span class="title text-lg">{{'MENU.SEARCH.NO_RESULTS' | translate}}</span>
            </div>
        </div>
    }
    </div>
</div>